import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../../models/filter.model';
import { Lookup } from '../../models/admin-models/lookup.model';

@Injectable({
    providedIn: 'root'
})
export class ClientStatusService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/clientstatuses/' + id).toPromise();
    }

    gridView() {
        return this.httpClient.get('api/clientstatuses')
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createClientStatus(lookup: Lookup) {
        return this.httpClient.post('api/clientstatuses/create', lookup.data).toPromise();
    }

    editClientStatus(lookup: Lookup) {
        return this.httpClient.post('api/clientstatuses/edit', lookup.data).toPromise();
    }

    deleteClientStatus(ids: Array<Number>) {
        return this.httpClient.post('api/clientstatuses/delete', ids).toPromise();
    }

}